module.exports = __webpack_public_path__ + "static/media/bipedge-second-purple-overlay.d1c3f29c.webp";